module.exports = __webpack_public_path__ + "img/user-fill.826c55f.svg";